var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "styled-components";
import { _p, _px, _py, _pt, _pr, _pb, _pl } from "./core";
export function p(values) {
  return function (_ref) {
    var theme = _ref.theme;
    return _p(values, theme);
  };
}
export function px(values) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return _px(values, theme);
  };
}
export function py(values) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return _py(values, theme);
  };
}
export function pt(values) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return _pt(values, theme);
  };
}
export function pr(values) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return _pr(values, theme);
  };
}
export function pb(values) {
  return function (_ref6) {
    var theme = _ref6.theme;
    return _pb(values, theme);
  };
}
export function pl(values) {
  return function (_ref7) {
    var theme = _ref7.theme;
    return _pl(values, theme);
  };
}
export var Padding = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", " \n  ", " \n  ", " \n  ", " \n  ", " \n  ", "\n"])), function (_ref8) {
  var inline = _ref8.inline;
  return inline && "display: inline-block;";
}, function (_ref9) {
  var all = _ref9.all,
      theme = _ref9.theme;
  return all && _p(all, theme);
}, function (_ref10) {
  var horizontal = _ref10.horizontal,
      theme = _ref10.theme;
  return horizontal && _px(horizontal, theme);
}, function (_ref11) {
  var vertical = _ref11.vertical,
      theme = _ref11.theme;
  return vertical && _py(vertical, theme);
}, function (_ref12) {
  var top = _ref12.top,
      theme = _ref12.theme;
  return top && _pt(top, theme);
}, function (_ref13) {
  var right = _ref13.right,
      theme = _ref13.theme;
  return right && _pr(right, theme);
}, function (_ref14) {
  var bottom = _ref14.bottom,
      theme = _ref14.theme;
  return bottom && _pb(bottom, theme);
}, function (_ref15) {
  var left = _ref15.left,
      theme = _ref15.theme;
  return left && _pl(left, theme);
});
Padding.displayName = "Padding";
export default Padding;